module.exports = __webpack_public_path__ + "img/straddle-premium-icon.5859a77f.svg";